// apps/web/src/components/primitives/isian/ref.ts
import type { Ref } from 'react'

/** One element for several refs (a control's own and the caller's, e.g. react-hook-form's). */
export function pasangRef<T>(...refs: readonly (Ref<T> | undefined)[]): (el: T | null) => void {
  return (el) => {
    for (const ref of refs) {
      if (typeof ref === 'function') ref(el)
      else if (ref !== null && ref !== undefined) ref.current = el
    }
  }
}
